import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import ChairSvg from 'src/components/svg/ChairSvg';
import styles from './LoadingIndicator.module.css';

//#region [Props]
type LoadingIndicatorProps = {
  className?: string;
  position?: "AbsoluteCenter" | "TopCenter" | "InlineCenter";
  size?: "large" | "small";
  label?: string;
};
//#endregion

//#region [Component]
export default function LoadingIndicator(t0) {
  const $ = _c(13);
  const {
    className,
    position: t1,
    size: t2,
    label
  } = t0;
  const position = t1 === undefined ? "AbsoluteCenter" : t1;
  const size = t2 === undefined ? "large" : t2;
  const t3 = position === "TopCenter";
  const t4 = position === "InlineCenter";
  const t5 = size === "small";
  let t6;
  if ($[0] !== className || $[1] !== t3 || $[2] !== t4 || $[3] !== t5) {
    t6 = classNames(styles.SLoadingIndicator, className, {
      [styles.topCenter]: t3,
      [styles.inlineCenter]: t4,
      [styles.small]: t5
    });
    $[0] = className;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      "--speed": "2s",
      "--delay-2": "0.25s",
      "--delay-3": "0.5s",
      "--ICONCOLOR_OVERRIDE": "var(--palette-hovedfarge)"
    };
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <ChairSvg className={styles.SChairSvg} isFilled={true} />;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== size) {
    t9 = size === "large" && <><ChairSvg className={styles.SChairSvg} isFilled={true} /><ChairSvg className={styles.SChairSvg} isFilled={true} /></>;
    $[7] = size;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== label || $[10] !== t6 || $[11] !== t9) {
    t10 = <div className={t6} aria-label={label} style={t7 as React.CSSProperties}>{t8}{t9}</div>;
    $[9] = label;
    $[10] = t6;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  return t10;
}
//#endregion